import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AdminMainComponent,LabManagerComponent,SqaCodeManagerComponent } from '../components';
import { AdministratorMenuComponent } from '../components/shared/menu/administrator-menu/administrator-menu.component';
import { TicketManagerComponent } from '../components/administrator/ticket-manager/ticket-manager.component';
import { AlertManagerComponent } from '../components/administrator/alert-manager/alert-manager.component';
import { ServiceRequestComponent } from '../components/administrator/service-request/service-request.component';
import { BatchManagerComponent } from '../components/administrator/batch-manager/batch-manager.component';
import{PartsManagerComponent}from '../components/administrator/parts-manager/parts-manager.component'
import { SerialNumberMergeComponent} from '../components/administrator/serial-number-merge/serial-number-merge.component'
import { AuthGuardService } from '../services';

const routes: Routes = [
    {
      path: '',
      component: ServiceRequestComponent ,
      pathMatch: 'full',
      //Start:Commented By Harikesh on 10-July-2017
      /*
      children: [
        {
          path:'ServiceRequest', component:AdministratorMenuComponent 
        },
        {
          path:'TicketManager', component:TicketManagerComponent
        },
        {
          path:'AlertManager', component:AlertManagerComponent
        },
        {
          path:'PartsManager', component:PartsManagerComponent
        }
      ]*/
    //End:Commented By Harikesh on 10-July-2017
    },
    {
      path:'ServiceRequest',
      component:ServiceRequestComponent,
      pathMatch:'full',
      canActivate: [AuthGuardService],
      data: { roles: ['ADMIN','BOM','BOMX'],title:"Service Request" } 
    },
    {
      path:'TicketManager',
      component:TicketManagerComponent,
      pathMatch:'full',
      canActivate: [AuthGuardService],
      data: { roles: ['ADMIN','BOM','BOMX'] ,title:"Ticket Manager"} 
    },
    {
      path:'AlertManager',
      component:AlertManagerComponent,
      pathMatch:'full',
      canActivate: [AuthGuardService],
      data: { roles: ['ADMIN','BOM','BOMX'] ,title:"Alert Manager"} 
    }
    ,
    {
      path:'BatchManager',
      component:BatchManagerComponent,
      pathMatch:'full',
      canActivate: [AuthGuardService],
      data: { roles: ['ADMIN'] ,title:"Batch Manager"} 
    },
    {
      path:'PartsManager',
      component:PartsManagerComponent,
      
      pathMatch:'full',
      canActivate: [AuthGuardService],
      data: { roles: ['ADMIN'] ,title:"Part Manager" } 
    }
    ,
    // {
    //   path:'BatchManager',
    //   component:BatchManagerComponent,
    //   pathMatch:'full',
    //   canActivate: [AuthGuardService],
    //   data: { roles: ['ADMIN','BOM','BOMX'],title:"Batch Manager" } 
    // }
    // ,
    {
      path:'SQACodeManager',
      component:SqaCodeManagerComponent,
      pathMatch:'full',
      canActivate: [AuthGuardService],
      data: { roles: ['ADMIN'],title:"SQA Code Manager" } 
    },
    {
      path:'SerialNumberMerge',
      component:SerialNumberMergeComponent,
      pathMatch:'full',
      canActivate: [AuthGuardService],
      data: { roles: ['ADMIN'] ,title:"Serial Number Merge"} 
    },
    {
      path:'LabManager',
      component:LabManagerComponent,
      pathMatch:'full',
      canActivate: [AuthGuardService],
      data: { roles: ['ADMIN'] ,title:"Lab Manager"} 
    }
  ];


@NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule]
  })
  export class AdministratorRoutingModule { }
